package com.eladfinish.bible.contest.screens.pairMatching.menu

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.copy_pairs
import com.eladfinish.bible.contest.create_pairs
import com.eladfinish.bible.contest.ic_settings_black
import com.eladfinish.bible.contest.menu_refresh
import com.eladfinish.bible.contest.new_game_pair_matching
import com.eladfinish.bible.contest.str_solution
import com.eladfinish.bible.contest.title_activity_settings
import com.eladfinish.bible.contest.ui.components.toolbar.SetToolbarConfiguration
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarActionConfig
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarActionPlacement
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarConfiguration
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarHeaderComponentConfig
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarIcon
import com.eladfinish.bible.contest.ui.components.toolbar.model.ToolbarKind
import com.eladfinish.bible.contest.ui.menus.actions.PairMatchingToolbarAction
import com.eladfinish.bible.contest.ui.menus.actions.ToolbarActionEmitter
import dev.icerock.moko.resources.compose.painterResource
import dev.icerock.moko.resources.desc.desc
import kotlinx.collections.immutable.toImmutableList

enum class PairMatchingToolbarId {
    NEW_GAME,
    SHOW_SOLUTION,
    COPY_PAIRS,
    CREATE_PAIRS,
    REFRESH,
    SETTINGS,
}

@Composable
internal fun PairMatchingMenu(
    title: String,
    toolbarEmitter: ToolbarActionEmitter<PairMatchingToolbarAction>,
) {
    SetToolbarConfiguration(
        configuration = ToolbarConfiguration(
            kind = ToolbarKind.PairMatching,
            title = ToolbarHeaderComponentConfig.Text(text = title),
            actions = listOfNotNull(
                ToolbarActionConfig.TextActionRes(
                    id = PairMatchingToolbarId.NEW_GAME,
                    stringDesc = SharedRes.strings.new_game_pair_matching.desc(),
                    onClick = {
                        toolbarEmitter.emit(PairMatchingToolbarAction.NewGame)
                    },
                ),
                ToolbarActionConfig.TextActionRes(
                    id = PairMatchingToolbarId.SHOW_SOLUTION,
                    stringDesc = SharedRes.strings.str_solution.desc(),
                    onClick = {
                        toolbarEmitter.emit(PairMatchingToolbarAction.ShowSolution)
                    },
                    placement = ToolbarActionPlacement.InOverflow,
                ),
                ToolbarActionConfig.TextActionRes(
                    id = PairMatchingToolbarId.COPY_PAIRS,
                    stringDesc = SharedRes.strings.copy_pairs.desc(),
                    onClick = {
                        toolbarEmitter.emit(PairMatchingToolbarAction.CopyPairs)
                    },
                    placement = ToolbarActionPlacement.InOverflow,
                ),
                ToolbarActionConfig.TextActionRes(
                    id = PairMatchingToolbarId.CREATE_PAIRS,
                    stringDesc = SharedRes.strings.create_pairs.desc(),
                    onClick = {
                        toolbarEmitter.emit(PairMatchingToolbarAction.CreatePairs)
                    },
                    placement = ToolbarActionPlacement.InOverflow,
                ).takeIf { false },
                ToolbarActionConfig.TextActionRes(
                    id = PairMatchingToolbarId.REFRESH,
                    stringDesc = SharedRes.strings.menu_refresh.desc(),
                    onClick = {
                        toolbarEmitter.emit(PairMatchingToolbarAction.Refresh)
                    },
                    placement = ToolbarActionPlacement.InOverflow,
                ),
                ToolbarActionConfig.IconAction(
                    id = PairMatchingToolbarId.SETTINGS,
                    icon = ToolbarIcon.PainterIcon(
                        painter = painterResource(imageResource = SharedRes.images.ic_settings_black)
                    ),
                    menuText = SharedRes.strings.title_activity_settings.desc(),
                    onClick = {
                        toolbarEmitter.emit(PairMatchingToolbarAction.Settings)
                    },
                    placement = ToolbarActionPlacement.InOverflow,
                ),
            ).toImmutableList()
        )
    )
}
